import { render, staticRenderFns } from "./BanksDialog.vue?vue&type=template&id=07058d8a"
import script from "./BanksDialog.vue?vue&type=script&lang=js"
export * from "./BanksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports